import { render, staticRenderFns } from "./top_menu_partition.vue?vue&type=template&id=3b15f413&"
import script from "./top_menu_partition.vue?vue&type=script&lang=js&"
export * from "./top_menu_partition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports